import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { PlanillaPartido } from '../PlanillaPartido/PlanillaPartido';
import {
  PlanillaPartidoEnVivoJSON,
  PlanillaPartidoEnVivo,
} from '../PlanillaPartidoEnVivo/PlanillaPartidoEnVivo';
import { TimeoutXPlanillaJSON, TimeoutXPlanilla } from '../TimeoutXPlanilla/TimeoutXPlanilla';
import { EventoXPlanilla, EventoXPlanillaJSON } from './EventoXPlanilla';

export interface PlanillaEventsUpdateInfoJSON {
  events: EventoXPlanillaJSON[];
  timeouts: TimeoutXPlanillaJSON[];
  planillaEnVivo: PlanillaPartidoEnVivoJSON;
  // info general del partido agregar
}

export interface PlanillaEventsUpdateInfo {
  events: EventoXPlanilla[];
  timeouts: TimeoutXPlanilla[];
  planillaEnVivo: PlanillaPartidoEnVivo;
  // info general del partido agregar
}

export class EventoXPlanillaSystem {
  private readonly base = '/eventoxplanillas';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getEventoXPlanillaIdentifiedBy(id: string): Promise<EventoXPlanilla> {
    const data = await this.requestHandler.get<EventoXPlanillaJSON>(`${this.base}/${id}`);
    return EventoXPlanilla.fromJSON(data);
  }

  async getList(): Promise<EventoXPlanilla[]> {
    const data = await this.requestHandler.get<EventoXPlanillaJSON[]>(`${this.base}`);
    return data.map((entity) => EventoXPlanilla.fromJSON(entity));
  }

  async getListForDropdown(): Promise<EventoXPlanilla[]> {
    const data = await this.requestHandler.get<EventoXPlanillaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => EventoXPlanilla.fromJSON(entity));
  }

  async save(entity: EventoXPlanilla) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<EventoXPlanillaJSON, EventoXPlanillaJSON>(
      this.base,
      data
    );
    return EventoXPlanilla.fromJSON(savedEntity);
  }

  async getListByPlanilla(planillaPartido: PlanillaPartido): Promise<EventoXPlanilla[]> {
    const data = await this.requestHandler.get<EventoXPlanillaJSON[]>(
      `${this.base}/planilla/${planillaPartido.getId()}`
    );
    return data.map((entity) => EventoXPlanilla.fromJSON(entity));
  }

  async updatesForPlanilla(updateInfo: PlanillaEventsUpdateInfo) {
    const events = updateInfo.events.map((e) => e.toJSON());
    const timeouts = updateInfo.timeouts.map((e) => e.toJSON());
    const planillaEnVivo = updateInfo.planillaEnVivo.toJSON();
    const ret = await this.requestHandler.post<PlanillaEventsUpdateInfoJSON, PlanillaEventsUpdateInfoJSON>(
      `${this.base}/update-eventos-for-planilla`,
      {
        events: events,
        timeouts: timeouts,
        planillaEnVivo: planillaEnVivo,
      }
    );
    return {
      events: ret.events.map((e) => EventoXPlanilla.fromJSON(e)),
      timeouts: ret.timeouts.map((e) => TimeoutXPlanilla.fromJSON(e)),
      planillaEnVivo: PlanillaPartidoEnVivo.fromJSON(ret.planillaEnVivo),
    };
  }

  async deactivateEvent(id: string): Promise<unknown> {
    return await this.requestHandler.put(`${this.base}/deactivate-event/${id}`, {});
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
